import { Icon, Fill, Circle, Stroke, Style, Text } from 'ol/style';
import { Carto } from './carte-config.js';

const COLOR_PRIMARY = '#2c465d';
const COLOR_PRIMARY_ON = '#ffffff';

export function getClusterStyleFunction(options) {
  let clusterStyle = (cluster) => {
    const size = cluster.get('features').length;
    // Qu'un seul élément parmis le cluster, on le stylise au lieu de faire un cluster de 1
    if (size === 1) {
      return createStyleForSingleFeature(cluster, options);
    }
    return createStyleForCluster(cluster, size);
  };
  return clusterStyle;
}

let styleCache = [];
function createStyleForCluster(cluster, size) {
  const selected = !!cluster.get('selected');
  let innerStyle = styleCache[`${size.toString()}_${selected.toString()}`];
  if (innerStyle) {
    return innerStyle;
  }
  const fillColor = selected ? COLOR_PRIMARY : COLOR_PRIMARY_ON;
  const strokeColor = selected ? COLOR_PRIMARY_ON : COLOR_PRIMARY;

  innerStyle = new Style({
    image: new Circle({
      radius: 20,
      fill: new Fill({
        color: fillColor,
      }),
    }),
    text: new Text({
      font: 'normal normal bold 16px/24px Nunito',
      text: size.toString(),
      fill: new Fill({
        color: strokeColor,
      }),
    }),
  });
  styleCache[size] = innerStyle;
  return innerStyle;
}

export function getDefaultStyle(index) {
  if (index === undefined || index === null) {
    return Carto.config.defaultStyle;
  }

  return {
    ...Carto.config.defaultStyle,
    ...(Carto.config.styles[index % Carto.config.styles?.length] ?? {}),
  };
}

const DEFAULT_MARKER_STYLE = {
  true: Carto.markers?.markerNegatifSynthese,
  false: Carto.markers?.markerSynthese,
};
// Quick access
const styles = {
  AireEtude: {
    styleIndex: 3,
    ...DEFAULT_MARKER_STYLE,
  },
  OeuvreObjet: {
    styleIndex: 1,
    true: Carto.markers.markerNegatifMobilier,
    false: Carto.markers.markerMobilier,
  },
  OeuvreArchitecture: {
    styleIndex: 0,
    true: Carto.markers.markerNegatifArchitecture,
    false: Carto.markers.markerArchitecture,
  },
};

export function createStyleForSingleFeature(cluster) {
  const features = cluster.get('features');
  const feature = features ? cluster.get('features')[0] : cluster;
  const typeDossier = feature.get('typeDossier');
  const styleConfig = styles[typeDossier] || DEFAULT_MARKER_STYLE;
  const style =
    Carto.config.styles[styleConfig.styleIndex] || Carto.config.defaultStyle;
  const stroke = style?.['stroke-color']
    ? new Stroke({ color: style?.['stroke-color'] })
    : null;

  // Les configurations des couleurs de style sont actuellement en hexa.
  // Pour gérer la transparence, OpenLayers 6 repose sur des couleurs au format rgba au lieu d'une propriété
  // supplémentaire "opacity". On tente de convertir la couleur de fill en rgba
  const fill = style?.['fill-color']
    ? new Fill({ color: style?.['fill-color'] })
    : null;

  return new Style({
    geometry: feature.getGeometry(),
    image: new Icon({
      src: styleConfig[!!cluster.get('selected')],
    }),
    stroke,
    fill,
  });
}

// Convertion d'une couleur en hexa vers rgba
export function toRgba(color, alpha) {
  if (!color) {
    return null;
  }
  return color + alpha.toString(16).padStart(2, '0');
}

// Convertion d'un nombre allant de 0 à 100 en valeur allant de 0 à 255
export function toAlpha(number) {
  return Math.ceil((number / 100) * 255);
}
